<template>
  <div class="modal-vue address-popup">
    <span class="container-icon" title="Закрыть" @click="closeModal">
      <mdicon name="close" width="22" height="22"/> 
    </span> 
    <form @submit.prevent="saveAddress">
      <div class="add-address-container">
        <div class="container-end">
          <div class="group-label-input">
            <label>Индекс<span class="icon-require">*</span></label>
            <input type="number" v-model="newAddressArray[0]" required>
          </div>
        </div>
        <div class="container-end">
          <div class="group-label-input">
            <label>Субъект<span class="icon-require">*</span></label>
            <input type="text" v-model="newAddressArray[1]" required>
          </div>
        </div>
        <div class="container-end">
          <div class="group-label-input">
            <label>Район</label>
            <input type="text" v-model="newAddressArray[2]">
          </div>
        </div>
        <div class="container-end">
          <div class="group-label-input">
            <label>Населенный пункт<span class="icon-require">*</span></label>
            <input type="text" v-model="newAddressArray[3]" required>
          </div>
        </div>
        <div class="container-end">
          <div class="group-label-input">
            <label>Улица</label>
            <input type="text" v-model="newAddressArray[4]">
          </div>
        </div>
        <div class="container-end">
          <div class="group-label-input">
            <label>Дом</label>
            <input type="text" v-model="newAddressArray[5]">
          </div>
        </div>
        <div class="container-end">
          <div class="group-label-input">
            <label>Офис</label>
            <input type="text" v-model="newAddressArray[6]">
          </div>
        </div>
      </div>
      <button class="btn btn-default" type="submit">Сохранить</button>
    </form>
  </div>
</template>
  
<script>
  export default {
    name: 'AddressForm',
    props: ["newAddressArrayForm"],
    data() {
      return {
        newAddressArray: this.newAddressArrayForm,
      };
    },

    watch: {
      'newAddressArray': {
        handler(newValue) {
          this.$emit('updateNewAddressArrayForm', newValue)
        },
        deep: true
      },
    },

    methods: {
      saveAddress() {
        this.$emit('saveAddress', this.newAddressArray)
      },

      closeModal() {
        this.$emit('closeModal', false)
      }
    },

  };
  </script>